import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../Components/ui/PageShell';
import { useLayout } from '../layout/AppLayout';
import { getUserType } from '../utils/authStorage';

function RequirementsHub() {
  const { openFormModal } = useLayout();
  const userType = getUserType();
  const createAction = userType === 'TeamLead' ? 'create-tl-requirement' : 'create-requirement';
  const listPath = userType === 'TeamLead' ? '/team/requirements' : '/Requirments';

  return (
    <PageShell
      title="Requirements"
      subtitle="Create new requirements or open the requirement list to manage jobs and candidate pipeline."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Requirements' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-dashboard-grid">
        <button type="button" className="hr-dashboard-card hr-dashboard-card-btn" onClick={() => openFormModal(createAction)}>
          <h3>Add Requirement</h3>
          <p>Create a new client requirement</p>
        </button>
        <Link to={listPath} className="hr-dashboard-card">
          <h3>Requirement List</h3>
          <p>View, filter, assign recruiters, and track candidate progress</p>
        </Link>
      </div>
    </PageShell>
  );
}

export default RequirementsHub;
